import { z } from "zod";

// ── Route 14: POST /api/visibility/gap-content/generate ─────────

/**
 * Wire-level response for POST /api/visibility/gap-content/generate.
 * Returned immediately after the Temporal workflow is started.
 */
export const GapContentGenerateResponse = z.object({
  draftId: z.string(),
  workflowId: z.string(),
  status: z.string(),
});
export type GapContentGenerateResponse = z.infer<
  typeof GapContentGenerateResponse
>;

// ── Route 15: GET /api/visibility/gap-content/:draftId/status ───

/**
 * Wire-level response for GET /api/visibility/gap-content/[id]/status.
 * Polled by the CLI until status reaches "generated" or "failed".
 */
export const GapContentStatusResponse = z.object({
  id: z.string(),
  status: z.string(),
  documentId: z.string().nullable().optional(),
  publicationChannel: z.string().nullable().optional(),
  channelReasoning: z.string().nullable().optional(),
  currentStep: z.string().nullable().optional(),
  errorMessage: z.string().nullable().optional(),
});
export type GapContentStatusResponse = z.infer<typeof GapContentStatusResponse>;
